import React, { useEffect, useState } from "react";
import { setSidebarStatus } from "actions/user";
import { ALL_PERMISSIONS } from "constants/permissionsConstants";
import { useHttp } from "hooks/useHttp";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import EyeImg from "assets/images/icons/eye-fill.png";
import Arrow from "assets/images/leftArr.png";
import SortImg from "assets/images/sort.png";
import DefaultImage from "assets/images/user.png";
import Loader from "components/Loader";
import {
  sortByDate,
  FROM_NEWER_TO_OLDER,
  FROM_OLDER_TO_NEWER,
} from "helpers/sortByDate";
import {
  getFilterByCompanyId,
  getFilterView,
} from "api/filterView/getFilterView";
import moment from "moment";
import { eventTrack } from "helpers/ga4Helper";
import { computeFinalPermissions } from 'helpers/finalPermissions';

export default function FilterView() {
  const dispatch = useDispatch();
  const history = useHistory();

  const userInfoRedux = useSelector((s) => s.user.userInfo);

  const usersPermissionRedux = useSelector((s) => s.user.userPermission);
  const companyPermissionRedux = useSelector((s) => s.user.companyPermission);
  const allPermissionRedux = useSelector((s) => s.user.allPermission);
  const FinalPermissions = computeFinalPermissions({
    userInfo: userInfoRedux,
    allPermission: allPermissionRedux,
    companyPermission: companyPermissionRedux,
    userPermission: usersPermissionRedux,
  });

  const [searchValue, setSearchValue] = useState("");
  const [allList, setAllList] = useState([]);
  const [list, setList] = useState([]);
  const [sortedToNewer, setSortedToNewer] = useState(false);

  const { loading: apiLoading, request: getFilteredViewAPI } = useHttp({
    requestCallback: () => getFilterByCompanyId(userInfoRedux?.company),
    onLoad: (res) => {
      setAllList(res);
      setList(res);
    },
    onError: (res) => {},
  });

  useEffect(() => {
    getFilteredViewAPI();
  }, []);

  useEffect(() => {
    handleSearch(searchValue);
  }, [searchValue]);

  const handleSearch = (keyword) => {
    const filteredResult = list?.filter(
      (list) =>
        list?.name.toLowerCase().includes(keyword.toLowerCase()) ||
        list.projectId.title.toLowerCase().includes(keyword.toLowerCase())
    );

    if (keyword.length > 0) {
      setList(filteredResult);
    } else {
      setList(allList);
    }
  };

  const sort = () => {
    if (sortedToNewer) {
      setList(sortByDate(list, FROM_OLDER_TO_NEWER));
    } else {
      setList(sortByDate(list, FROM_NEWER_TO_OLDER));
    }
  };
  return (
    <>
      {apiLoading && <Loader />}
      <div className="personal-area min-h-100">
        <div className="inner-header-position">
          <div className="custom-container d-flex align-items-center justify-content-between flex-wrap">
            <div className="d-flex align-items-center">
              <div
                onClick={() => dispatch(setSidebarStatus(true))}
                className="cursor-pointer"
              >
                <img src={Arrow} className="left-arrow-img" />
              </div>
              <p className="my-heading f-14 ml-3 mr-3">Filter View</p>
            </div>
            <div
              className="projActionButtons d-flex flex-wrap"
              style={{ maxWidth: "100vw" }}
            >
              <input
                type="text"
                className="search-bar"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder="Search"
              />
              <div className="vr mx-3"></div>
              <div className="btn-tool-group">
                {(userInfoRedux?.superAdmin || userInfoRedux?.companyAdmin) && (
                  <>
                    <button
                      onClick={() => {
                        if (
                          FinalPermissions?.includes(
                            ALL_PERMISSIONS.PROJECT_VIEW
                          )
                        ) {
                          history.push(`/admin/projects-settings`);
                        } else if (
                          FinalPermissions?.includes(
                            ALL_PERMISSIONS.STATUS_VIEW
                          )
                        ) {
                          history.push(`/admin/statuses`);
                        } else {
                          history.push(`/admin/user-permissions`);
                        }
                        eventTrack(
                          "Navigate-Admin-Section-Action",
                          "Navigate-Admin-Section",
                          userInfoRedux?.name,
                          "+1",
                          false,
                          "+1"
                        );
                      }}
                      className="bg-bid px-3 mr-0"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="19"
                        viewBox="0 0 14 19"
                        fill="none"
                      >
                        <path
                          d="M0.333984 18.3335C0.333984 14.6516 3.31875 11.6668 7.00065 11.6668C10.6826 11.6668 13.6673 14.6516 13.6673 18.3335H0.333984ZM7.00065 10.8335C4.23815 10.8335 2.00065 8.596 2.00065 5.8335C2.00065 3.071 4.23815 0.833496 7.00065 0.833496C9.76315 0.833496 12.0007 3.071 12.0007 5.8335C12.0007 8.596 9.76315 10.8335 7.00065 10.8335Z"
                          fill="white"
                        />
                      </svg>
                      Admin
                    </button>
                    <div className="vr mx-3"></div>
                  </>
                )}

                <button
                  onClick={() => {
                    setSortedToNewer(!sortedToNewer);
                    sort();
                    eventTrack(
                      "Sort-FilterView-Action",
                      "Sort-FilterView",
                      userInfoRedux?.name,
                      "+1",
                      false,
                      "+1"
                    );
                  }}
                  className="px-3 bg-white text-bid shadow-hover d-flex align-items-center leading-1"
                >
                  <img
                    src={SortImg}
                    className={`${"w-15 mr-2"} ${
                      sortedToNewer ? "upsideDown-svg" : ""
                    } `}
                  />
                  Sort
                </button>

                <button
                  disabled={apiLoading}
                  onClick={() => {
                    getFilteredViewAPI();
                  }}
                  className="px-3 bg-white text-bid shadow-hover"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                  >
                    <path
                      d="M3.55149 2.19418C5.01232 0.931059 6.9166 0.166992 8.99935 0.166992C13.6017 0.166992 17.3327 3.89795 17.3327 8.50033C17.3327 10.2804 16.7745 11.9302 15.8237 13.2842L13.166 8.50033H15.666C15.666 4.81843 12.6813 1.83366 8.99935 1.83366C7.20753 1.83366 5.58082 2.54055 4.38287 3.69068L3.55149 2.19418ZM14.4472 14.8065C12.9863 16.0696 11.0821 16.8337 8.99935 16.8337C4.39697 16.8337 0.666016 13.1027 0.666016 8.50033C0.666016 6.72021 1.22417 5.07046 2.17502 3.71653L4.83268 8.50033H2.33268C2.33268 12.1822 5.31745 15.167 8.99935 15.167C10.7912 15.167 12.4179 14.4601 13.6159 13.31L14.4472 14.8065Z"
                      fill="#3A5765"
                    />
                    <path
                      d="M3.55149 2.19418C5.01232 0.931059 6.9166 0.166992 8.99935 0.166992C13.6017 0.166992 17.3327 3.89795 17.3327 8.50033C17.3327 10.2804 16.7745 11.9302 15.8237 13.2842L13.166 8.50033H15.666C15.666 4.81843 12.6813 1.83366 8.99935 1.83366C7.20753 1.83366 5.58082 2.54055 4.38287 3.69068L3.55149 2.19418ZM14.4472 14.8065C12.9863 16.0696 11.0821 16.8337 8.99935 16.8337C4.39697 16.8337 0.666016 13.1027 0.666016 8.50033C0.666016 6.72021 1.22417 5.07046 2.17502 3.71653L4.83268 8.50033H2.33268C2.33268 12.1822 5.31745 15.167 8.99935 15.167C10.7912 15.167 12.4179 14.4601 13.6159 13.31L14.4472 14.8065Z"
                      fill="black"
                      fillOpacity="0.2"
                    />
                  </svg>
                  Refresh
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="assestmgmt-table-div mt-3">
          <table className="bid-table bid-table-small border-top-none sticky-table-header">
            <thead>
              <tr>
                <th>Name</th>
                <th>Project Name</th>
                <th>Rules</th>
                <th>Creation Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {list?.map((item, key) => (
                <tr key={key}>
                  <td>{item?.name}</td>
                  <td>{item?.projectId?.title}</td>
                  <td>{item?.rules?.length}</td>
                  <td>{moment(item?.date).format("DD/MM/YYYY")}</td>

                  <td>
                    {
                      <div
                        onClick={() => {
                          history.push(
                            `/personal-area/projects/${item?.projectId._id}/timelines/${item?.timelineId}`
                          );
                          eventTrack(
                            "View-FilterView-Model-Action",
                            "View-FilterView-Model",
                            userInfoRedux?.name,
                            "+1",
                            false,
                            "+1"
                          );
                        }}
                        className="cursor-pointer"
                      >
                        <img src={EyeImg} alt="eye" className="action-icon" />
                      </div>
                    }
                  </td>
                </tr>
              ))}

              {list?.length === 0 && <p className="m-3">No record found</p>}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
